import api from './axios';

// Resolve relative storage URLs to full backend URLs
const BACKEND_ORIGIN = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api')
  .replace(/\/api$/, '');

export const resolveLogoUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BACKEND_ORIGIN}${url}`;
};

export const logoAPI = {
  /** GET /api/logo (public) */
  get: () => api.get('/logo'),
};
